export const getPeriodEyeOptions = (isUsingProjectAllocation, isUsingSchedulingPlanMode) => {
	return [
		{
			name: 'actualUtilization',
			translationId: 'project_budget.actuals',
			disabled: false,
			checked: true,
			nestedOptions: [
				{
					name: 'billableProjectHours',
					parent: 'actualUtilization',
					translationId: 'utilization.billable_time',
					checked: true,
					disabled: false,
				},
				{
					name: 'nonBillableProjectHours',
					parent: 'actualUtilization',
					translationId: 'utilization.non_billable_time',
					checked: true,
					disabled: false,
				},
				{
					name: 'internalHours',
					parent: 'actualUtilization',
					translationId: 'common.internal_time',
					checked: true,
					disabled: false,
				},
				{
					name: 'totalRegisteredHours',
					parent: 'actualUtilization',
					translationId: 'utilization.total_time',
					checked: true,
					disabled: false,
				},
				{
					name: 'overHours',
					parent: 'actualUtilization',
					translationId: 'utilization.over_time',
					checked: true,
					disabled: false,
				},
				{
					name: 'actualBillableUtilization',
					parent: 'actualUtilization',
					translationId: 'common.billable_utilization',
					checked: true,
					disabled: false,
				},
				{
					name: 'performance',
					parent: 'actualUtilization',
					translationId: 'common.performance',
					checked: false,
					disabled: false,
				},
				{
					name: 'actualNonBillableUtilization',
					parent: 'actualUtilization',
					translationId: 'common.non_billable_utilization',
					checked: false,
					disabled: false,
				},
				{
					name: 'actualInternalUtilization',
					parent: 'actualUtilization',
					translationId: 'utilization.internal_utilization',
					checked: false,
					disabled: false,
				},
				{
					name: 'actualResourceUtilization',
					parent: 'actualUtilization',
					translationId: 'common.resource_utilization',
					checked: true,
					disabled: false,
				},
			],
		},
		{
			name: 'plannedUtilization',
			translationId: 'common.planned',
			disabled: false,
			checked: isUsingProjectAllocation || isUsingSchedulingPlanMode,
			nestedOptions: [
				{
					name: 'billableProjectAllocation',
					parent: 'plannedUtilization',
					translationId: 'utilization.billable_time',
					checked: isUsingProjectAllocation || isUsingSchedulingPlanMode,
					disabled: false,
				},
				{
					name: 'nonBillableProjectAllocation',
					parent: 'plannedUtilization',
					translationId: 'utilization.non_billable_time',
					checked: isUsingProjectAllocation || isUsingSchedulingPlanMode,
					disabled: false,
				},
				{
					name: 'internalAllocation',
					parent: 'plannedUtilization',
					translationId: 'common.internal_time',
					checked: isUsingProjectAllocation || isUsingSchedulingPlanMode,
					disabled: false,
				},
				{
					name: 'totalAllocation',
					parent: 'plannedUtilization',
					translationId: 'utilization.total_time',
					checked: isUsingProjectAllocation || isUsingSchedulingPlanMode,
					disabled: false,
				},
				{
					name: 'overAllocation',
					parent: 'plannedUtilization',
					translationId: 'utilization.over_time',
					checked: isUsingProjectAllocation || isUsingSchedulingPlanMode,
					disabled: false,
				},
				{
					name: 'plannedBillableUtilization',
					parent: 'plannedUtilization',
					translationId: 'common.billable_utilization',
					checked: isUsingProjectAllocation || isUsingSchedulingPlanMode,
					disabled: false,
				},
				{
					name: 'plannedNonBillableUtilization',
					parent: 'plannedUtilization',
					translationId: 'common.non_billable_utilization',
					checked: false,
					disabled: false,
				},
				{
					name: 'plannedInternalUtilization',
					parent: 'plannedUtilization',
					translationId: 'utilization.internal_utilization',
					checked: false,
					disabled: false,
				},
				{
					name: 'plannedResourceUtilization',
					parent: 'plannedUtilization',
					translationId: 'common.resource_utilization',
					checked: isUsingProjectAllocation || isUsingSchedulingPlanMode,
					disabled: false,
				},
			],
		},
		{
			name: 'actualVsPlan',
			translationId: 'utilization.actual_vs_plan',
			disabled: false,
			checked: false,
			nestedOptions: [
				{
					name: 'billableActualVsPlan',
					parent: 'actualVsPlan',
					translationId: 'utilization.billable_actual_vs_plan',
					checked: false,
					disabled: false,
				},
				{
					name: 'nonBillableActualVsPlan',
					parent: 'actualVsPlan',
					translationId: 'utilization.non_billable_actual_vs_plan',
					checked: false,
					disabled: false,
				},
				{
					name: 'internalActualVsPlan',
					parent: 'actualVsPlan',
					translationId: 'utilization.internal_actual_vs_plan',
					checked: false,
					disabled: false,
				},
				{
					name: 'totalActualVsPlan',
					parent: 'actualVsPlan',
					translationId: 'utilization.total_actual_vs_plan',
					checked: false,
					disabled: false,
				},
			],
		},
		{
			name: 'remaining',
			translationId: 'common.remaining',
			disabled: false,
			checked: false,
			nestedOptions: [
				{
					name: 'billableRemaining',
					parent: 'remaining',
					translationId: 'utilization.billable_time',
					checked: !isUsingProjectAllocation && !isUsingSchedulingPlanMode,
					disabled: false,
				},
				{
					name: 'nonBillableRemaining',
					parent: 'remaining',
					translationId: 'utilization.non_billable_time',
					checked: !isUsingProjectAllocation && !isUsingSchedulingPlanMode,
					disabled: false,
				},
				{
					name: 'internalRemaining',
					parent: 'remaining',
					translationId: 'common.internal_time',
					checked: !isUsingProjectAllocation && !isUsingSchedulingPlanMode,
					disabled: false,
				},
				{
					name: 'totalRemaining',
					parent: 'remaining',
					translationId: 'utilization.total_time',
					checked: !isUsingProjectAllocation && !isUsingSchedulingPlanMode,
					disabled: false,
				},
				{
					name: 'overtimeRemaining',
					parent: 'remaining',
					translationId: 'utilization.over_time',
					checked: false,
					disabled: false,
				},
				{
					name: 'remainingBillableUtilization',
					parent: 'remaining',
					translationId: 'common.billable_utilization',
					checked: !isUsingProjectAllocation && !isUsingSchedulingPlanMode,
					disabled: false,
				},
				{
					name: 'remainingNonBillableUtilization',
					parent: 'remaining',
					translationId: 'common.non_billable_utilization',
					checked: false,
					disabled: false,
				},
				{
					name: 'remainingInternalUtilization',
					parent: 'remaining',
					translationId: 'utilization.internal_utilization',
					checked: false,
					disabled: false,
				},
				{
					name: 'remainingResourceUtilization',
					parent: 'remaining',
					translationId: 'common.resource_utilization',
					checked: !isUsingProjectAllocation && !isUsingSchedulingPlanMode,
					disabled: false,
				},
			],
		},
		{
			name: 'forecast',
			translationId: 'common.forecasted',
			disabled: false,
			checked: false,
			nestedOptions: [
				{
					name: 'billableForecast',
					parent: 'forecast',
					translationId: 'utilization.billable_time',
					checked: false,
					disabled: false,
				},
				{
					name: 'nonBillableForecast',
					parent: 'forecast',
					translationId: 'utilization.non_billable_time',
					checked: false,
					disabled: false,
				},
				{
					name: 'internalForecast',
					parent: 'forecast',
					translationId: 'common.internal_time',
					checked: false,
					disabled: false,
				},
				{
					name: 'totalForecast',
					parent: 'forecast',
					translationId: 'utilization.total_time',
					checked: false,
					disabled: false,
				},
				{
					name: 'overtimeForecast',
					parent: 'forecast',
					translationId: 'utilization.over_time',
					checked: false,
					disabled: false,
				},
				{
					name: 'forecastBillableUtilization',
					parent: 'forecast',
					translationId: 'common.billable_utilization',
					checked: true,
					disabled: false,
				},
				{
					name: 'forecastNonBillableUtilization',
					parent: 'forecast',
					translationId: 'common.non_billable_utilization',
					checked: false,
					disabled: false,
				},
				{
					name: 'forecastInternalUtilization',
					parent: 'forecast',
					translationId: 'utilization.internal_utilization',
					checked: false,
					disabled: false,
				},
				{
					name: 'forecastResourceUtilization',
					parent: 'forecast',
					translationId: 'common.resource_utilization',
					checked: true,
					disabled: false,
				},
			],
		},
		{
			name: 'availability',
			translationId: 'utilization.availability',
			disabled: false,
			checked: true,
			nestedOptions: [
				{
					name: 'workinghours',
					parent: 'availability',
					translationId: 'utilization.working_time',
					checked: false,
					disabled: false,
				},
				{
					name: 'timeOff',
					parent: 'availability',
					translationId: 'common.time_off',
					checked: true,
					disabled: false,
				},
				{
					name: 'availableHours',
					parent: 'availability',
					translationId: 'utilization.available_time',
					checked: true,
					disabled: false,
				},
			],
		},
	];
};
